import React, { useEffect, useState } from "react";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";

type Props = {
  onChange?: any;
};

const Search = (props: Props) => {
  const [userInput, setUserInput] = useState("");

  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  useEffect(() => {
    props.onChange(userInput);
    console.log("useEffect search", userInput);
  }, [userInput]);

  return (
    <div className="search-container">
      {/* <h3 className='title'>{this.props.title}</h3> */}
      <SearchIcon className="search-icon" />
      <input
        className="search-input"
        placeholder="Search"
        onChange={(e) => handleChange(e)}
        value={userInput}
      />
    </div>
  );
};

export default Search;
